import DynamicComponentBaseProps from "features/shared/components/dynamicComponetWrapper/DynamicComponentBaseProps";
import IAppState from "infrastructure/store/IAppState";
import ContractsCountState from "infrastructure/store/contractsCount/ContractsCountState";
import React from "react";
import { useSelector } from "react-redux";
import TopBarCommodityIcon from "./TopBarCommodityIcon";
import { CommodityDetail } from "features/contracts/enums/commodityDetail";
import TopBarIcon from "./TopBarIcon";

interface Props extends DynamicComponentBaseProps {}

const TopBarIconsTeplarnyBrno = (props: Props) => {
  // store
  const contractsCount = useSelector<IAppState, ContractsCountState>(
    (store) => store.contractsCount
  ).contractsCount;

  // sub-renders
  const renderCommodityIcons = () => {
    if (contractsCount.length > 0) {
      return contractsCount.map((item, index) =>
        renderCommodityIcon(item.commodityDetail!, item.count!, index)
      );
    } else {
      let icons: CommodityDetail[] = [
        "HeatCustomer",
        "ElectricityCustomer",
        "GasCustomer",
        "eMobility",
      ];

      return icons.map((item, index) => renderCommodityIcon(item, 0, index));
    }
  };

  const renderCommodityIcon = (
    commodityDetail: CommodityDetail,
    contractCount: number,
    index: number
  ) => {
    return (
      <TopBarCommodityIcon
        commodityDetail={commodityDetail}
        active={contractCount > 0}
        key={index}
      />
    );
  };

  // render
  return (
    <div className="d-none d-xl-flex align-items-center ml-3">
      {renderCommodityIcons()}
      <TopBarIcon iconName="cold" />
      <TopBarIcon iconName="photovoltaics" />
      <TopBarIcon iconName="hydrogen" iconSize={1.45} />
      <TopBarIcon iconName="services" />
    </div>
  );
};

export default TopBarIconsTeplarnyBrno;
